import dayjs from 'dayjs';
import { THERAPY_DATA_CODE } from '@utils/constants/medicalCodes';
const { RDN_PROC_COMP_DATE } = THERAPY_DATA_CODE;

const transformBulkTherapyDataSearch = (data) => {
  if (!data || data.length === 0) return {};

  return data.reduce(
    (
      acc,
      {
        valueQuantity,
        code,
        component,
        updatedAt,
        valueDateTime,
        valueString,
        valueBoolean,
        valueInteger,
        id,
        patientId,
        status,
        effectiveDateTime,
      },
    ) => {
      if (valueBoolean !== null || valueBoolean !== undefined) {
        const { code: medicalCode, display } = code.coding[0];

        acc[medicalCode] = {
          id,
          patientId,
          value: valueBoolean,
          unit: null,
          display,
          updatedAt,
          status,
        };
      }

      // Process root value date time
      if (valueDateTime || valueString || valueInteger) {
        const { code: medicalCode, display } = code.coding[0];

        let date = valueDateTime;
        if (medicalCode === RDN_PROC_COMP_DATE) {
          date = dayjs(valueDateTime).utc().format('YYYY-MM-DD');
        }
        acc[medicalCode] = {
          id,
          patientId,
          value: date ?? valueString ?? valueInteger,
          unit: null,
          display,
          updatedAt,
          status,
        };
      }

      // Process root level valueQuantity
      if (valueQuantity) {
        const { code: medicalCode } = code.coding[0];

        acc[medicalCode] = {
          id,
          patientId,
          value: valueQuantity.value,
          unit: valueQuantity.unit,
          display: code.text,
          updatedAt,
          status,
          effectiveDateTime,
        };
      }

      // Process components which are multiple parts of a parent component like BP_Panel_at_enroll
      // BP_Panel_at_enroll is comprised of components SystolicBP_at_enroll and DiastolicBP_at_enroll
      if (component && component.length > 0) {
        component.forEach((comp) => {
          if (comp.code.coding && comp.code.coding.length > 0) {
            const { code: medicalCode, display } = comp.code.coding[0];
            const { value_quantity } = comp;

            if (medicalCode && value_quantity) {
              acc[medicalCode] = {
                id,
                patientId,
                value: value_quantity.value,
                unit: value_quantity.unit,
                display,
                updatedAt,
                status,
              };
            }
          }
        });
      }

      return acc;
    },
    {},
  );
};

export default transformBulkTherapyDataSearch;
